/**
 * Calculates the included tax of a product
 * 
 * @param amount the quantity of the product (e. g. 1)
 * @param netPrice the net price of the product (e. g. 1500)
 * @param tax the tax of the product (e. g. 1900)
 * @param grossPrice the gross price of the product (e. g. 1785)
 * 
 */
export const calculateIncludingTax = ({ amount, netPrice, grossPrice, tax }) => {
  return (
      (Number(amount) || 0) * (Number(grossPrice) || 0) - (Number(amount) || 0) * (Number(netPrice) || 0)
  );
};

/**
 * Calculates the net subtotal price of the products
 * 
 * @param products Array of products (see structure below)
 * @param products.amount the quantity of the product (e. g. 1)
 * @param products.netPrice the net price of the product (e. g. 1500)
 * @param products.tax the tax of the product (e. g. 1900)
 * @param products.grossPrice the gross price of the product (e. g. 1785)
 * 
 */
export const calculateSubtotalPrice = (products = []) => {
  return products.reduce((prev, product) => {
      return prev + product.netPrice * Number(product.amount);
  }, 0)
}

/**
 * Calculates the summed VAT price of the products
 * 
 * @param products Array of products (see structure below)
 * @param products.amount the quantity of the product (e. g. 1)
 * @param products.netPrice the net price of the product (e. g. 1500)
 * @param products.tax the tax of the product (e. g. 1900)
 * @param products.grossPrice the gross price of the product (e. g. 1785)
 * 
 */
export const calculateSummedVatPrice = (products = []) => {
  return products.reduce((prev, product) => {
      return prev + (product.grossPrice - product.netPrice) * Number(product.amount);
  }, 0)
}

/**
 * Calculates the total gross price (net prices + vat prices) of the products
 * 
 * @param products Array of products (see structure below)
 * @param products.amount the quantity of the product (e. g. 1)
 * @param products.netPrice the net price of the product (e. g. 1500)
 * @param products.tax the tax of the product (e. g. 1900)
 * @param products.grossPrice the gross price of the product (e. g. 1785)
 * 
 */
export const calculateTotalPrice = (products = []) => {
  return calculateSubtotalPrice(products) + calculateSummedVatPrice(products);
}